import React, { useState } from 'react';
import { InputBase, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SearchBarProps } from './types';

const SearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  background: theme.palette.background.paper, 
  padding: '10px 19px',
  height:"35px", 
  border: '1px solid #D5D5D5',
}));

const SearchIcon = styled('img')({
  width: '17px',
  height: '17px',
  marginRight: '18px',
});

const StyledInput = styled(InputBase)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '14px',
  width: '100%',
}));

export const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = 'Search',
}) => {
  const [value, setValue] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    onSearch(newValue);
  };

  return (
    <SearchContainer>
      <SearchIcon src="https://cdn.builder.io/api/v1/image/assets/TEMP/d4f2ea29ae6ea13b0a675eff71da06cfc3c4f04e9f218a65339f8403e2c41aa6?placeholderIfAbsent=true&apiKey=2a10ec9e4ca34b8dabe8333a653afe75" alt="" loading="lazy" />
      <StyledInput
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        inputProps={{ 'aria-label': 'search' }}
      />
    </SearchContainer>
  );
};